const openGridModal = el => {
	const modal = document.querySelector('.grid--modal')
	const infoModalContent = document.querySelector('#infomodal--content')
	const modalContent = el.querySelector('[data-id="modal--text"]').innerHTML

	console.log(modalContent)

	infoModalContent.innerHTML = modalContent

	modal.classList.add('active')
}

const closeGridModal = el => {
	const modals = document.querySelectorAll('.grid--modal')
	modals.forEach(modal => modal.classList.remove('active'))
}

if (document.querySelectorAll('.grid--modal')) {
	document.addEventListener('keyup', e => {
		console.log(e.key)
		e.key === 'Escape' || e.key === "Esc" ? closeGridModal() : null
	})
}